<svg width="24" height="24" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
 <polygon transform="translate(6,5)" points="8 14 8 11 5.79 11 9.21 3 12 3 12 0 4 0 4 3 6.21 3 2.79 11 0 11 0 14"/>
</svg>
